import { render, staticRenderFns } from "./dashKpsr.vue?vue&type=template&id=44204ac7"
import script from "./dashKpsr.vue?vue&type=script&lang=js"
export * from "./dashKpsr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44204ac7')) {
      api.createRecord('44204ac7', component.options)
    } else {
      api.reload('44204ac7', component.options)
    }
    module.hot.accept("./dashKpsr.vue?vue&type=template&id=44204ac7", function () {
      api.rerender('44204ac7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/dashKpsr.vue"
export default component.exports